import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';

type Props = {
  emailMessagesBatchId?: string | null;
};
export default function EmailMessagesBatch({ emailMessagesBatchId }: Props) {
  const platformId = useCurrentPlatformId();
  if (!emailMessagesBatchId) {
    return <>--</>;
  }

  const href = `/o/${platformId}/events?timePeriod=ALL&batchId=${emailMessagesBatchId}`;
  return (
    <Link href={href} underline="hover">
      {emailMessagesBatchId}
    </Link>
  );
}
